// extracted by mini-css-extract-plugin
export default {"container":"Announcement_container__e9OqG","content":"Announcement_content__Z8vWY"};